var map = {
	"./gallery_00.jpg": 1296,
	"./gallery_01.jpg": 1297,
	"./gallery_02.jpg": 1298,
	"./gallery_03.jpg": 1299,
	"./img_00.jpg": 1300,
	"./img_01.jpg": 1301,
	"./img_02.jpg": 1302,
	"./img_03.jpg": 1303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1295;